
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://diblqesgwgpvpsbttojj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRpYmxxZXNnd2dwdnBzYnR0b2pqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg4NTczMTIsImV4cCI6MjA1NDQzMzMxMn0.77cos-vT7vfdsOhDNx_ni1SIxXAZPI-_9jfiCYfYwhk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
